import { useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import React from 'react';

interface CircleProps {
	color?: string;
	width?: string;
	height?: string;
}

export const Circle: React.FC<CircleProps> = (props) => {
	const { palette } = useTheme();
	const { color = palette.global.ui9, width = 8, height = 8 } = props;

	return (
		<svg width={width} height={height} viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle opacity="0.3" cx="4.36914" cy="4.36951" r="4" fill={color} />
		</svg>
	);
};
